module.exports = __webpack_public_path__ + "static/media/form.e959f92a.svg";